import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  // HttpClient API get() method
  get<T>(url: string, requestParam: any): any {
    return this.http.get<T>(url, { params: requestParam })
      .pipe(
        map((res: any) => res),
        catchError(this.handleError)
      )
  }
  getImage<T>(url: string, requestParam: any): any {
    return this.http.get(url, { params: requestParam, responseType: 'blob' })
      .pipe(map((res: any) => res),
        catchError(this.handleError)
      )
  }


  // HttpClient API post() method
  post<T>(url: string, data: any, requestParam: any): any {
    return this.http.post<T>(url, data, { params: requestParam })
      .pipe(
        map((res: any) => res),
        catchError(this.handleError)
      )
  }


  // HttpClient API put() method 
  put<T>(url: string, data: any) {
    return this.http.put<T>(url, JSON.stringify(data))
      .pipe(
        catchError(this.handleError)
      )
  }

  // HttpClient API delete() method
  delete<T>(url: string) {
    return this.http.delete<T>(url)
      .pipe(
        catchError(this.handleError)
      )
  }


  // Error handling 
  handleError(error: any) {
    return throwError(error);
  }
}
